import { render, staticRenderFns } from "./SettingsLight.vue?vue&type=template&id=504c483f&scoped=true&"
import script from "./SettingsLight.vue?vue&type=script&lang=js&"
export * from "./SettingsLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504c483f",
  null
  
)

export default component.exports